/**
 * Procedurally-generated FX particle textures. Bey sprites and the arena
 * (dish + background) are loaded as PNGs — see public/assets + BootScene.
 */
import Phaser from 'phaser';

/** A soft round particle used for sparks/glows. */
export function generateFxTextures(scene: Phaser.Scene): void {
  if (!scene.textures.exists('spark')) {
    const g = scene.add.graphics();
    g.fillStyle(0xffffff, 1);
    g.fillCircle(8, 8, 7);
    g.generateTexture('spark', 16, 16);
    g.clear();

    // Soft glow (fading disc).
    for (let i = 12; i >= 0; i--) {
      g.fillStyle(0xffffff, (i / 12) * 0.12);
      g.fillCircle(24, 24, (i / 12) * 24);
    }
    g.generateTexture('glow', 48, 48);
    g.destroy();
  }
}
